<template>
  <div class="container-login">
    <div class="corpo-lado-esquerdo-login">
      <h4 class="rotina-interna">ROTINA INTERNA MICROVIX</h4>
      <div class="descricao-login">
        <h4 class="titulo-login">Linx</h4>
        <h4 class="subtitulo-login">MICROVIX</h4>
        <h4 class="nome-rotina-login">{{ nomeAplicacao }}</h4>
      </div>
      <p class="copyright">© Linx - Líder em Tecnologia de Gestão para o Varejo</p>
    </div>
    <div class="corpo-lado-direito-login">
      <img src="../assets/images/lg-logo.png" alt="Logo Linx" />
      <div class="formulario-login" @keyup.enter="autenticar">
        <div class="container-input-login">
          <label for="input-usuario-login" class="label-input-login">Usuário</label>
          <input class="input-login" id="input-usuario-login" type="text" v-model="usuario" placeholder="Portal 03" />
        </div>
        <div class="container-input-login">
          <label for="input-senha-login" class="label-input-login">Senha</label>
          <input class="input-login" id="input-senha-login" type="password" v-model="senha" />
        </div>
        <div class="container-input-login">
          <label for="input-os-login" class="label-input-login">ID Oportunidade</label>
          <input class="input-login" id="input-os-login" type="text" v-model="idOportunidade" placeholder="Dynamics" />
        </div>
        <button class="autenticar-button-login" @dispara-erros="setMensagemErros" @click="autenticar" id="autenticarBtn">AUTENTICAR</button>
        <div class="col text-right">
          <router-link
            :to="{
              name: 'RecuperacaoSenha',
              query: montaQueryParametro,
            }"
            class="btn btn-link control-label"
            title="Recuperar Senha"
            :disabled="isFetching"
            >Esqueci minha senha</router-link
          >
        </div>
      </div>
    </div>

    <carregando descricao="Aguarde enquanto buscamos seus dados." :status="status" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      usuario: '',
      senha: '',
      idOportunidade: '',
      status: false,
      isFetching: false,
    };
  },
  computed: {
    objetoValidacao() {
      const data = [];

      data.push(this.montaObjetoValidacao(['campoObrigatorio'], this.usuario, 'input-usuario-login'));
      data.push(this.montaObjetoValidacao(['campoObrigatorio'], this.senha, 'input-senha-login'));
      data.push(this.montaObjetoValidacao(['campoObrigatorio', 'apenasNumeros'], this.idOportunidade, 'input-os-login'));

      return data;
    },
    montaObjetoCommit() {
      return {
        usuario: this.usuario,
        senha: this.senha,
        idOportunidade: this.idOportunidade,
      };
    },
    montaQueryParametro() {
      return this.usuario && { usuario: this.usuario };
    },
    nomeAplicacao() {
      return process.env.VUE_APP_NOME_APLICACAO;
    },
  },
  methods: {
    autenticar() {
      const possuiErrosValidacao = this.validaDados(this.objetoValidacao);

      if (!possuiErrosValidacao) {
        this.status = true;
        this.atualizaDadosStore('dispatch', 'setDataDynamics', this.montaObjetoCommit)
          .then(() => {
            this.status = false;
            this.$router.push('/dados/cnpj');
          })
          .catch(() => {
            this.status = false;
          });
      }
    },
  },
};
</script>

<style>
.container-login {
  display: flex;
  width: 100%;
  height: 100vh;
}

.corpo-lado-esquerdo-login {
  display: flex;
  flex-direction: column;

  width: 25%;
  height: 100%;

  background-color: #5b2e90;
  padding: 0 30px;
}

.descricao-login {
  display: flex;
  flex-direction: column;
  justify-content: center;

  height: 100%;
  margin-top: -75px;
}

.titulo-login {
  font-size: 2.625rem;
  color: #ffb200;
  font-weight: 300;
  margin: 0;
}

.subtitulo-login {
  color: #fff;
  font-size: 3rem;
  font-weight: 300;
  margin: 0 0 8px 0;
}

.nome-rotina-login {
  color: #fff;
  font-weight: 700;
  font-size: 1.75rem;
  margin: 0;
}

.rotina-interna {
  color: #fff;
  font-weight: 400;
  font-size: 1.7rem;
  margin-top: 75px;
}

.copyright {
  color: #fff;
  font-size: 0.8rem;
  position: absolute;
  bottom: 0;
  left: 30px;
}

.corpo-lado-direito-login {
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 75%;
  padding-top: 50px;
}

.formulario-login {
  width: 45%;
  padding-top: 50px;
}

.container-input-login {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
}

.label-input-login {
  color: #333;
  margin-bottom: 0.2rem;
}

.input-login {
  height: 35px;
  border: 1px solid #ced4da;
  padding: 0.375rem 0.75rem;
  color: #495057;
  font-size: 1rem;
  outline: none;
}

.input-login:focus {
  border-color: #2c004b;
}

.autenticar-button-login {
  width: 100%;
  padding: 0.375rem 0.75rem;

  background-color: #ffb200;
  font-size: 15px;
  font-family: Dosis, sans-serif;
  border: none;
  outline: none;
  font-weight: 500;

  transition: background-color 0.2s ease;

  cursor: pointer;
}

.autenticar-button-login:hover {
  color: #333;
  background-color: #cc8e00;
}
</style>
